var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
import { Component, Prop, CustomElement, Watch, COMPONENT_STATE, html, nothing, directive, styleMap, State } from '@sick-davinci/ce-decorators';
import { Icon } from '../icon/Icon';
import { IconRef } from '../icon/IconRef';
/**
 * Base class for slider
 */

export let AbstractSlider = (_dec = Component({
  abstract: true,
  dependencies: [Icon, IconRef]
}), _dec2 = Prop({
  reflectAsAttribute: true
}), _dec3 = Reflect.metadata("design:type", Number), _dec4 = Prop({
  reflectAsAttribute: true
}), _dec5 = Reflect.metadata("design:type", Number), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", String), _dec20 = Prop(), _dec21 = Reflect.metadata("design:type", String), _dec22 = Prop({
  reflectAsAttribute: true
}), _dec23 = Reflect.metadata("design:type", Boolean), _dec24 = Watch('showValueField'), _dec25 = Reflect.metadata("design:paramtypes", []), _dec26 = State(), _dec27 = Reflect.metadata("design:type", Number), _dec28 = Watch('disabled'), _dec29 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = (_class2 = class AbstractSlider extends CustomElement {
  constructor(...args) {
    super(...args);
    this._decimals = 0;
    this._min = 0;
    this._max = 100;
    this._ticks = 1;

    _initializerDefineProperty(this, "legend", _descriptor, this);

    _initializerDefineProperty(this, "unit", _descriptor2, this);

    _initializerDefineProperty(this, "disabled", _descriptor3, this);

    _initializerDefineProperty(this, "iconLeft", _descriptor4, this);

    _initializerDefineProperty(this, "iconRight", _descriptor5, this);

    _initializerDefineProperty(this, "iconSrcLeft", _descriptor6, this);

    _initializerDefineProperty(this, "iconSrcRight", _descriptor7, this);

    _initializerDefineProperty(this, "showValueField", _descriptor8, this);

    this.KEY_CODE_TAB = 'Tab';
    this.KEY_CODE_ARROW_LEFT = ['ArrowLeft', 'Left'];
    this.KEY_CODE_ARROW_UP = ['ArrowUp', 'Up'];
    this.KEY_CODE_ARROW_RIGHT = ['ArrowRight', 'Right'];
    this.KEY_CODE_ARROW_DOWN = ['ArrowDown', 'Down'];
    this.SET = new WeakMap();
    this.PRESS_EVENT_TYPE = 'onpointerdown' in document ? 'pointerdown' : 'ontouchstart' in document ? 'touchstart' : 'mousedown';
    this.MOVE_EVENT_TYPE = 'onpointerdown' in document ? 'pointermove' : 'ontouchstart' in document ? 'touchmove' : 'mousemove';
    this.RELEASE_EVENT_TYPE = 'onpointerdown' in document ? 'pointerup' : 'ontouchstart' in document ? 'touchend' : 'mouseup';
    this.CANCEL_EVENT_TYPE = 'onpointerdown' in document ? 'pointercancel' : 'ontouchstart' in document ? 'touchend' : 'mouseleave';
    this.IS_TOUCH = window.navigator.msMaxTouchPoints > 0 || !!('ontouchstart' in window);
    this.pressEventDirective = directive(callback => part => {
      if (this.SET.has(part)) {
        return;
      } else {
        part.element.addEventListener(this.PRESS_EVENT_TYPE, callback);
        this.SET.set(part, true);
      }
    });
    this.lastPickedKnob = 0;
    this.requestAnimationFrame = null;
    this.knobPositions = [];
    this._value = [];
    this.knobPressed = false;
    this.showValueFieldChanged = false;

    _initializerDefineProperty(this, "_valueBubbleKnobOfInterest", _descriptor9, this);

    this._updateGuard = false;

    this.focusEvent = () => {
      if (!this.showValueField) {
        this.selectKnob();
      }
    };

    this.focusOutEvent = () => {
      this.removeCurrentKnobClass('focused');
      this.elementBubble.classList.remove('knob_hover');
      this.lastPickedKnob = 0;
    };

    this.downEvent = event => {
      this._prepareKnobDragging(event);
    };

    this.releaseEvent = event => {
      this.knobPressed = false;
      event.preventDefault();
      event.stopPropagation();

      if (this.requestAnimationFrame) {
        window.cancelAnimationFrame(this.requestAnimationFrame);
        this.requestAnimationFrame = null;
      }

      const value = this.calcValueFrom(this.getPositionXOf(event));
      this.updateValueAndEmit(value, false, true);
      document.removeEventListener(this.MOVE_EVENT_TYPE, this.moveEvent);
      document.removeEventListener(this.RELEASE_EVENT_TYPE, this.releaseEvent);
      document.removeEventListener(this.CANCEL_EVENT_TYPE, this.releaseEvent);
      this.removeCurrentKnobClass('pressed');

      if (this !== document.activeElement) {
        this.removeCurrentKnobClass('focused');
      }

      this.elementBubble.classList.remove('knob_pressed');
    };

    this.moveEvent = event => {
      event.preventDefault();
      event.stopPropagation();

      if (!this.requestAnimationFrame) {
        // debounce events for a smoother experience
        this.requestAnimationFrame = window.requestAnimationFrame(() => {
          const value = this.calcValueFrom(this.getPositionXOf(event));
          this.updateValueAndEmit(value, true, false);
          this.requestAnimationFrame = null;
        });
      }
    };

    this.roundWithTicks = value => {
      if (this.ticks > 0) {
        const displacement = (value - this._min) % this.ticks;

        if (displacement >= this.ticks / 2) {
          value = value + (this.ticks - displacement);
        } else {
          value = value - displacement;
        }

        return value;
      } else {
        return value;
      }
    };

    this.keyDownEvent = _event => {};

    this.onMouseEnter = event => {
      if (this.knobPressed) {
        return;
      }

      const value = this.calcValueFrom(this.getPositionXOf(event));
      this._valueBubbleKnobOfInterest = this._getClosestKnobFor(value);
      this.elementBubble.classList.add('knob_hover');
      this.scheduleRender(true);
    };

    this.onMouseLeave = () => {
      this.elementBubble.classList.remove('knob_hover');
    };

    this._clickJumpEvent = event => {
      this.removeCurrentKnobClass('focused');
      const value = this.calcValueFrom(this.getPositionXOf(event));
      this.lastPickedKnob = this._getClosestKnobFor(value);
      this.addCurrentKnobClass('focused');
      this.updateValueAndEmit(value, true, true);
      this.focus();
    };
  }

  /**
   * Specifies the minimum value of the slider that is allowed.
   */
  set min(val) {
    this._min = val;
    this.updateState();
  }

  get min() {
    return this._min;
  }

  /**
   * Specifies the maximum value of the slider that is allowed.
   */
  set max(val) {
    this._max = val;
    this.updateState();
  }

  get max() {
    return this._max;
  }

  /**
   * Specifies the size of an increment between values
   */
  set ticks(value) {
    this._ticks = value;
    this._decimals = 0;

    if (this._ticks) {
      this._ticks = Math.abs(this._ticks);
      const parts = this.ticks.toString().split('.');
      this._decimals = parts.length > 1 ? parts[1].length : 0;
    } else {
      this._ticks = 1;
    }

    this.updateState();
  }

  get ticks() {
    return this._ticks;
  }
  /**
   * Shows the legend below the slider.
   * Shows the minimum, maximum and mean of those attributes.
   */


  showValueFieldChangeHandler() {
    this.showValueFieldChanged = true;
  }

  /**
   * Limits the decimals of the given value to the decimals count of the currently set ticks.
   *
   * @param value
   * @returns
   */
  truncDecimals(value) {
    return this._decimals ? value = parseFloat(value.toFixed(this._decimals)) : value;
  }
  /**
   * Implement empty render Method to pacify typescript compiler
   */


  render() {
    throw new Error('Abstract Components must not be rendered.');
  }

  renderSlider(value) {
    return html`
     ${this.showValueField ? html`
        <div class="slider-wrapper" tabindex="-1">
          ${this.renderSliderElement()}
          <div class="value-fields">
            ${this._renderValueField(0, value)}
            ${value.length > 1 ? this._renderValueField(1, value) : html``}
          </div>
        </div>
        ` : html`${this.renderSliderElement()}`}
    `;
  }
  /**
   * Actual template to be rendered. Small varieties between different Slider implementations can be realised by overwriting the renderSpecific() method.
   */


  renderSliderElement() {
    return html`
    <div class="slider noselect">
      <div class="slotwrapper">
        <slot></slot>
      </div>
      <div class=icon>${this.renderIcon(this.iconSrcLeft, this.iconLeft)}</div>
      <div class="bar_container" @="${this.pressEventDirective(this._clickJumpEvent)}">
        <div class="bar_outer" >
          ${this._drawInnerBar()}
          <div class="touch_container">
            ${this._addKnob0()}
            ${this.addValueBubble0()}
            ${this.renderSpecific()}
          </div>
        </div>
        ${this.displayLegend()}
      </div>
      <div class=icon>${this.renderIcon(this.iconSrcRight, this.iconRight)}</div>
    </div>
    `;
  }

  componentConnected() {
    this.updateState();
    this.addEventListener('focus', this.focusEvent);
    this.addEventListener('focusout', this.focusOutEvent);
    this.addEventListener('keydown', this.keyDownEvent);
    this.disabledChangeHandler(this.disabled, this.disabled);

    if (this.IS_TOUCH) {
      this.addEventListener('touchend', this.onMouseLeave);
    }
  }

  componentDisconnected() {
    this.removeEventListener('focus', this.focusEvent);
    this.removeEventListener('focusout', this.focusOutEvent);
    this.removeEventListener('keydown', this.keyDownEvent);
    this.removeMouseListenersForKnob(this._elementKnob0);

    if (this.IS_TOUCH) {
      this.removeEventListener('touchend', this.onMouseLeave);
    }

    document.removeEventListener(this.MOVE_EVENT_TYPE, this.moveEvent);
    document.removeEventListener(this.RELEASE_EVENT_TYPE, this.releaseEvent);
    document.removeEventListener(this.CANCEL_EVENT_TYPE, this.releaseEvent);
  }

  componentFirstRender() {
    this.maintainDomReferences();
  }

  componentDidRender() {
    if (this.showValueFieldChanged) {
      this.showValueFieldChanged = false;
      this.maintainDomReferences();
    }
  }

  /**
   * Call this function any time the state of this slider needs to be updated.
   * @protected
   */
  updateState() {
    if (!this.isConnected) {
      // Do not update this slider's state if it's not connected.
      return;
    } // At this point this slider's properties should be in sync with their corresponding attributes.


    if (this._updateGuard) {
      return;
    }

    this._updateGuard = true;

    try {
      this.updateSyncedState();
    } finally {
      this._updateGuard = false;
    }
  }
  /**
   * When this function is called the slider must update its state.
   * The slider can assume that its attributes and properties are in sync.
   * Do not(!) call this function directly but call {@link updateState} instead.
   * @protected
   */


  updateSyncedState() {
    throw new Error('updateSyncedState must be overwritten by sub-classes');
  }

  maintainDomReferences() {
    this.removeMouseListenersForKnob(this._elementKnob0);
    this._elementKnob0 = this.shadowRoot.querySelector('[data-id="0"]');
    this.addMouseListenersForKnob(this._elementKnob0);
    this.elementBubble = this.shadowRoot.querySelector('.value-bubble');
  }

  addMouseListenersForKnob(knob) {
    if (knob === null || knob === undefined || this.IS_TOUCH) {
      return;
    }

    knob.addEventListener('mouseover', this.onMouseEnter);
    knob.addEventListener('mouseout', this.onMouseLeave);
  }

  removeMouseListenersForKnob(knob) {
    if (knob === null || knob === undefined) {
      return;
    }

    knob.removeEventListener('mouseover', this.onMouseEnter);
    knob.removeEventListener('mouseout', this.onMouseLeave);
  }

  selectKnob() {
    this.addCurrentKnobClass('focused');
    this._valueBubbleKnobOfInterest = this.lastPickedKnob;
    this.elementBubble.classList.add('knob_hover');
    this.scheduleRender(true);
  }

  _prepareKnobDragging(event) {
    this.knobPressed = true;
    event.preventDefault();
    event.stopPropagation();
    document.addEventListener(this.MOVE_EVENT_TYPE, this.moveEvent);
    document.addEventListener(this.RELEASE_EVENT_TYPE, this.releaseEvent);
    document.addEventListener(this.CANCEL_EVENT_TYPE, this.releaseEvent);
    this.updateKnobSelectionTo(event.target.dataset.id);
    this.addCurrentKnobClass('pressed');
    this.elementBubble.classList.add('knob_pressed');
    this.focus();
  }

  disabledChangeHandler(_, newValue) {
    if (this._componentState !== COMPONENT_STATE.INIT) {
      // avoid setting illegal attribute set during construction
      if (!newValue) {
        // with this code the focused slider has a blue highlighting-box
        this.setAttribute('tabindex', '0');
      }
    }
  }

  getPositionXOf(event) {
    let positionX = event.clientX;

    if (positionX === undefined) {
      positionX = event.changedTouches[0].clientX;
    }

    return positionX;
  }

  calcValueFrom(positionX) {
    const {
      left,
      width
    } = this.shadowRoot.querySelector('.bar_container').getBoundingClientRect();
    const normalized = positionX - left;
    let value = this.map(normalized, 0, width, this._min, this._max);
    value = this.roundWithTicks(value);
    return this.validateValue(value);
  }
  /**
   * Ensures that the given value lies in [{@link min}, {@link max}]
   * @param value - the value to be validated
   * @returns the validated value
   */


  validateValue(value) {
    if (isNaN(value)) {
      value = 0;
    }

    if (value <= this._min) {
      value = this._min;
    } else if (value >= this._max) {
      value = this._max;
    }

    return value;
  }
  /**
   * Maps the given value from the value-range [inMin, inMax] to the value-range [outMin, outMax]
   */


  map(value, inMin, inMax, outMin, outMax) {
    return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
  }
  /**
   * Aligns the given value to the {@link ticks} of this slider.
   * @param value - the value to be aligned with the ticks
   * @returns the aligned value
   */


  displayLegend() {
    let legend = null;

    if (this.legend) {
      legend = html`
      <div class ="legend">
        <div class ="verticalLines">
          <div class="verticalLine"></div>
          <div class="verticalLine"></div>
          <div class="verticalLine"></div>
        </div>
        <div class ="values">
          <div class="value left">${this._min}${this.unit}</div>
          <div class="value center">${(this._max - this._min) / 2 + this._min}${this.unit}</div>
          <div class="value right">${this._max}${this.unit}</div>
        </div>
      </div>
    `;
    }

    return legend;
  }

  renderIcon(iconSrc, icon) {
    if (iconSrc) {
      return html`<davinci-icon-ref src=${iconSrc}></davinci-icon-ref>`;
    }

    if (icon) {
      return html`<davinci-icon icon=${icon}></davinci-icon>`;
    }

    return nothing;
  }
  /**
   * add a class to current knob
   * @param className - class to add
   */


  addCurrentKnobClass(className) {
    this.shadowRoot.querySelector('[data-id="' + this.lastPickedKnob + '"]').classList.add(className);
  }
  /**
   * remove a class from current knob
   * @param className - class to remove
   */


  removeCurrentKnobClass(className) {
    this.shadowRoot.querySelector('[data-id="' + this.lastPickedKnob + '"]').classList.remove(className);
  }
  /**
   * Increment the value by one tick
   */


  increment() {
    const value = this.lastPickedKnob === 0 ? this._value[0] : this._value[1];
    return this.validateValue(value + this.ticks);
  }
  /**
   * Decrement the value by one tick
   */


  decrement() {
    const value = this.lastPickedKnob === 0 ? this._value[0] : this._value[1];
    return this.validateValue(value - this.ticks);
  }
  /**
   * @virtual
   * Add small changes in template
   *
   */


  renderSpecific() {// to be overwritten
  }
  /**
   * Update the knob selection
   *
   * @param _id selected knob
   */


  updateKnobSelectionTo(id) {
    this._valueBubbleKnobOfInterest = parseInt(id, 0);
  }
  /**
   * @virtual
   * @param _event
   */


  /**
   * @virtual
   * Updates the knob position to match a value
   *
   * @param _value - value the knob position should match
   * @param _emitInput - specifies if an input event should be emitted
   * @param _emitChange - specifies if a change event should be emitted
   */
  updateValueAndEmit(_value, _emitInput, _emitChange) {} // ToDo @6.0.0 -> refactor to onNumericFieldChange(_newValue: number, _index: number)
  // valueIndex: number -> rename to index & move position
  // initialValue -> remove
  // newValue -> change Array<number> -> number & change position

  /**
   * Synchronizes the elements value with the internal value of a value field
   *
   * @virtual
   * @param _valueIndex - indicates which valueField value has changed
   * @param _initialValue - elements value before synchronization, needed for change detection in value field
   * @param _newValue - new value
   */


  synchronizeValueFieldValue(_valueIndex, _initialValue, _newValue) {} // ToDO @6.0.0 -> rename to overwriteNumericFieldValue

  /**
   * Set value of the input field.
   *
   * In case, the new value gets rounded to a value equals the old value (e.g. because of tick size)
   * the NumericField does not get informed about changes and so does not update it's value.
   * So we have to synchronize the value manually.
   *
   * @param index - id of the input field
   * @param value - new value
   */


  overwriteInputFieldValue(index, value) {
    const element = this.shadowRoot.getElementById('NumericField_' + index);
    element.value = value;
  }

  _drawInnerBar() {
    return html`${this.knobPositions[1] ? html`<div class="bar_inner" style="${styleMap({
      'margin-left': this.knobPositions.length === 1 ? '0%' : this.knobPositions[0] + '%',
      'margin-right': '0%',
      'width': this.knobPositions[1] - this.knobPositions[0] + '%'
    })}"></div>` : html`<div class="bar_inner" style="${styleMap({
      'margin-left': '0%',
      'margin-right': this.knobPositions[0] + '%',
      'width': this.knobPositions[0] + '%'
    })}"></div>`}`;
  }
  /**
   * Format the given value to a fixed number of decimals if ticks is set.
   * It reflects the decimals count of the currently set ticks.
   *
   * @param value Format the given value to a fixe
   * @returns
   */


  formatBubbleValue(value) {
    if (this._decimals) {
      let fixed = value.toFixed(this._decimals);
      const parts = fixed.split('.');

      if (parts.length > 1) {
        parts[1] = parts[1].padEnd(this._decimals, '0');
        fixed = parts.join('.');
      }

      return fixed;
    }

    return value.toString();
  }
  /**
   * Adds a bubble displaying the current value of the selected knob
   */


  addValueBubble0() {
    const value = this._value[this._valueBubbleKnobOfInterest];
    const tipSizer = value === 0 ? 0 : ('' + Math.abs(value)).length * 1.5;
    const clipPath = `clip-path: polygon(0 0, 100% 0, 100% 80%, ${69 - tipSizer}% 80%, 50% 100%, ${31 + tipSizer}% 80%, 0% 80%);`;
    return html`
      <div class="value-bubble" style="${styleMap({
      left: `calc(${this.knobPositions[this._valueBubbleKnobOfInterest]}%)`
    })}">
        <div class="value-bubble-clip-path" style="${clipPath}">
          ${this.formatBubbleValue(value || 0)}
        </div>
      </div>
    `;
  }

  _addKnob0() {
    return html`<div class="knob" style="${styleMap({
      left: this.knobPositions[0] + '%'
    })}"
      @="${this.pressEventDirective(this.downEvent)}" data-id="0"><div class="knob_shadow"></div></div>`;
  }

  _renderValueField(valueIndex = 0, value) {
    let formatPattern = '0';

    if (this._decimals) {
      formatPattern += '.';
      formatPattern = formatPattern.padEnd(2 + this._decimals, '0');
    }

    return html`<davinci-numeric-field
      class="value-field"
      id="${'NumericField_' + valueIndex}"
      type="bare"
      .value=${value[valueIndex]}
      .min=${this._min}
      .max=${this._max}
      .ticks=${this.ticks}
      .formatPattern=${formatPattern}
      @change=${e => {
      // ToDo @6.0.0 -> directly call onNumericFieldChange(newValue: number, index: number)
      // newValue -> e.detail
      // valueIndex -> index
      const newValue = [...value];
      newValue[valueIndex] = e.detail;
      this.synchronizeValueFieldValue(valueIndex, value[valueIndex], newValue);
    }}
    ></davinci-numeric-field>`;
  }

  _getClosestKnobFor(value) {
    if (!this._value[1]) {
      return 0;
    }

    const closestValue = this._value.reduce((prev, curr) => {
      return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
    });

    return this._value[1] < value ? 1 : this._value.indexOf(closestValue);
  } // When user clicks on the slider, but not the knob, this method jumps the knob to the nearest possible position


}, (_applyDecoratedDescriptor(_class2.prototype, "min", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "min"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "max", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "max"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "ticks", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "ticks"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "legend", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "iconLeft", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "iconRight", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "iconSrcLeft", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "iconSrcRight", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "showValueField", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "showValueFieldChangeHandler", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "showValueFieldChangeHandler"), _class2.prototype), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "_valueBubbleKnobOfInterest", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "disabledChangeHandler", [_dec28, _dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "disabledChangeHandler"), _class2.prototype)), _class2)) || _class);
